import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface EstFormSaveDetail {
  form_name: any;
  part_no: any;
  schd_no: any;
  section_name: any;
  row_type: any;
  combination_key: any;
  form_key: any;
  form_line_key: any;
  line_attrib_key: any;
  attrib_type: any;
  attrib_prop_key: any;
  acct_ref_key: any;
  attrib_value: any;
  trans_details_key: any;
  trans_type_key: any;
  is_changed_flag: any;
  occurrence: number;
}

export interface EstFormSaveSettings {
  sso_id: any;
  screen_key: any;
  form_name: any;
  wf: any;
}

export interface EstFormSavePayload {
  details: EstFormSaveDetail[];
  settings: EstFormSaveSettings;
  globalParams: any;
  filterParams: any;
  combinationKey?: any;
}

@Injectable({ providedIn: 'root' })
export class EstFormService {

  constructor(private http: HttpClient) {}

  saveForm(baseUrl: string, payload: EstFormSavePayload): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=c4i7xh`;

    const params: any = {
      ...(payload.globalParams || {}),
      ...(payload.filterParams || {}),
      clob_data: JSON.stringify(payload.details),
      clob_settings: JSON.stringify(payload.settings),
      process_name: 'est-form-save',
      sso_id: payload.settings.sso_id,
      form_name: payload.settings.form_name,
      wf: payload.settings.wf || '',
    };

    if (payload.combinationKey != null) {
      params.combination_key = payload.combinationKey;
    }

    const body = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const v = params[key];
      if (v !== undefined && v !== null && v !== '') {
        body.set(key, String(v));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<any>(url, body.toString(), {
      headers,
      withCredentials: true,
    });
  }
}
